import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  orderTypes: [],
  allOrderTypes: [],
  totalPages: 0,
  totalRecords: 0,
  orderType: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_55: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_OrderTypes(state, orderTypes) {
    state.orderTypes = orderTypes.items;
    state.totalPages = orderTypes.totalPages;
    state.totalRecords = orderTypes?.totalRecords ?? 0;
  },
  SET_AllOrderTypes(state, orderTypes) {
    state.allOrderTypes = orderTypes;
  },
  SET_OrderType(state, orderType) {
    state.orderType = orderType;
  },
};
const actions = {
  errorOderType({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllOrderTypes({ commit, dispatch, rootState }) {
    return apiClient
      .get('/OrderTypes/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllOrderTypes', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOderType', error);
      });
  },
  addOrderType({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OrderTypes', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOderType', error);
      });
  },
  getOrderType({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/OrderTypes/ById?orderTypeId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_OrderType', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOderType', error);
      });
  },
  editOrderType({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OrderTypes/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOderType', error);
      });
  },
  deleteOrderType({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/OrderTypes/Remove?orderTypeId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOderType', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
